import React from "react";
import DualBarChartECharts from "./DualBarChartECharts";

const ActionCodes = ({ data }) => {



  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div style={{ flex: 1 }}>
        <DualBarChartECharts
          positiveData={data?.call_status_by_action_codes?.filter(
            (item) => item?.type === "positive"
          )}
          negativeData={data?.call_status_by_action_codes?.filter(
            (item) => item?.type === "negative"
          )}
          colors={["#F5B041"]}
          yLabel="No. of Cases ↓"
          leftGrid={{
            left: "2%",
            right: "55%",
            bottom: 60,
            containLabel: true,
          }}
          rightGrid={{
            left: "45%",
            right: "0%",
            bottom: 60,
            containLabel: true,
          }}
        />
      </div>
    </div>
  );
};

export default ActionCodes;
